import { useAtom } from 'jotai';
import { useNavigate } from 'react-router-dom';
import authAtom from '../authAtom';
import { publicClient } from '../api/clients';
import { loginResponseSchema } from '@minutes-system/backend/src/api/auth/schema';
import fetchAndValidate from '../../../lib/fetchAndValidate';

const useAuth = () => {
  const [auth, setAuth] = useAtom(authAtom);
  const navigate = useNavigate();
  const login = async (idToken: string) => {
    const loginResponse = await fetchAndValidate(
      publicClient.auth.login.$post({ json: { idToken } }) as Promise<Response>,
      loginResponseSchema
    );
    setAuth({ user: loginResponse.user, accessToken: loginResponse.accessToken });
    void navigate('/recordings');
  };

  const logout = async () => {
    try {
      await publicClient.auth.logout.$post();
    } catch (e) {
      console.error('Logout error:', e);
    } finally {
      setAuth(null);
      void navigate('/login');
    }
  };

  return {
    user: auth?.user ?? null,
    login,
    logout,
  };
};

export default useAuth;
